/**
 * Сохраняет значение в localStorage под указанным ключом.
 * @param key - Ключ для сохранения.
 * @param value - Значение для сохранения (будет сериализовано в JSON).
 */
export const saveToLocalStorage = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    }
    catch (error) {
        console.warn(`Failed to save to localStorage for key "${key}":`, error);
    }
};
/**
 * Загружает значение из localStorage по указанному ключу.
 * @param key - Ключ для загрузки.
 * @returns Десериализованное значение или null, если ключ не найден или произошла ошибка.
 */
export const loadFromLocalStorage = (key) => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }
    catch (error) {
        console.warn(`Failed to load from localStorage for key "${key}":`, error);
        return null;
    }
};
/**
 * Удаляет значение из localStorage по указанному ключу.
 * @param key - Ключ для удаления.
 */
export const removeFromLocalStorage = (key) => {
    try {
        localStorage.removeItem(key);
    }
    catch (error) {
        console.warn(`Failed to remove from localStorage for key "${key}":`, error);
    }
};
